import { Link } from 'react-router';
import { LinkButton, VerticalContainer } from '@/components';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { ChevronRightIcon } from '@/components/Icons';
import { ISelfResponse } from '@/shared/interfaces';
import { MyInformationApp } from '@/features/profile/widgets/my-information/MyInformationApp';
import { ProfilePaths } from '@/features/profile/model/types';
import { profileMenuItems } from '@/features/profile/model/profileMenuItems';

type ProfileMenuProps = {
    bootstrappedSelf: ISelfResponse;
    isAdolescent: boolean;
    hasVeterinarianCoverage: boolean;
};

export const ProfileMenu = ({
    bootstrappedSelf,
    isAdolescent,
    hasVeterinarianCoverage,
}: ProfileMenuProps) => {
    const visibleMenuItems = profileMenuItems.filter(
        (item) =>
            !(item.path === ProfilePaths.Household && isAdolescent) &&
            !(item.path === ProfilePaths.Pets && !hasVeterinarianCoverage),
    );

    return (
        <>
            <div className="hidden md:block">
                <MyInformationApp bootstrappedSelf={bootstrappedSelf} />
            </div>

            <h2 className="md:hidden">{R.MyProfile}</h2>
            <VerticalContainer spacing="none" className="md:hidden">
                {visibleMenuItems.map((item) => (
                    <Link
                        key={item.path}
                        to={`/${item.path}`}
                        className="flex items-center justify-between border-b border-(--color-border-muted) py-6 leading-tight text-(--color-text-primary) last:border-0"
                    >
                        <span>{item.title}</span>
                        <ChevronRightIcon />
                    </Link>
                ))}
            </VerticalContainer>

            <div className="mt-6 md:hidden">
                <LinkButton
                    variant="primary"
                    fullWidth={true}
                    href="/authentication/logoff"
                >
                    {R.Logoff}
                </LinkButton>
            </div>
        </>
    );
};
